import { computed, onBeforeMount, ref } from 'vue'
import { usePage } from '@inertiajs/vue3'

export const useTeamCoupon = () => {
  const page = usePage<{ isCouponValid: boolean; team?: any }>()

  const couponCode = ref('')
  const isCouponValid = computed(() => page.props.isCouponValid)

  onBeforeMount(() => {
    // Coupon code is valid if loaded from team object (like on billing page)
    if (page.props?.team?.coupon) {
      return (couponCode.value = page.props.team.coupon.code)
    }
  })

  return {
    couponCode,
    isCouponValid,
  }
}
